import React from 'react';

export default function Reactor6Icon({
  width = 64,
  height = 77,
  startColor = '#1E1E1E',
  midColor = '#EBEBEB',
  endColor = '#1E1E1E'
}) {
  const id = Math.random().toString(36).slice(2, 9);
  return (
    <svg width={width} height={height} viewBox="0 0 93.902 112.5" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <filter id={`fp-shadow-${id}`} x="-20%" y="-20%" width="140%" height="140%">
          <feGaussianBlur in="SourceAlpha" stdDeviation="2.5"/>
          <feOffset dx="0" dy="3" result="offsetblur"/>
          <feComponentTransfer><feFuncA type="linear" slope="0.45"/></feComponentTransfer>
          <feMerge><feMergeNode/><feMergeNode in="SourceGraphic"/></feMerge>
        </filter>
        <radialGradient id={`fp-shine-${id}`} cx="35%" cy="22%" r="65%">
          <stop offset="0%" stopColor="rgba(255,255,255,0.28)"/>
          <stop offset="55%" stopColor="rgba(255,255,255,0.06)"/>
          <stop offset="100%" stopColor="rgba(255,255,255,0)"/>
        </radialGradient>
      </defs>
      <g filter={`url(#fp-shadow-${id})`}>
      <g id="Group_BackLegs">
	<linearGradient id={`${id}_1_`} gradientUnits="userSpaceOnUse" x1="76.541" y1="87.5879" x2="85.8984" y2="87.5879">
		<stop offset="0" style={{stopColor: "#1E1E1E"}} />
		<stop offset="0.45" style={{stopColor: "#989898"}} />
		<stop offset="0.62" style={{stopColor: "#858585"}} />
		<stop offset="0.77" style={{stopColor: "#727272"}} />
		<stop offset="1" style={{stopColor: "#1E1E1E"}} />
	</linearGradient>
	<path fill={`url(#${id}_1_)`} d="M85.898,67.861h-9.357v23.221h1.917v16.232h5.523V91.082h1.917V67.861z" />
	<linearGradient id={`${id}_2_`} gradientUnits="userSpaceOnUse" x1="27.168" y1="87.5879" x2="36.5239" y2="87.5879">
		<stop offset="0" style={{stopColor: "#1E1E1E"}} />
		<stop offset="0.45" style={{stopColor: "#989898"}} />
		<stop offset="0.62" style={{stopColor: "#858585"}} />
		<stop offset="0.77" style={{stopColor: "#727272"}} />
		<stop offset="1" style={{stopColor: "#1E1E1E"}} />
	</linearGradient>
	<path fill={`url(#${id}_2_)`} d="M36.524,67.861h-9.356v23.221h1.916v16.232h5.524V91.082h1.916V67.861z" />
	<linearGradient id={`${id}_3_`} gradientUnits="userSpaceOnUse" x1="29.084" y1="99.1982" x2="34.6079" y2="99.1982">
		<stop offset="0" style={{stopColor: "#1E1E1E"}} />
		<stop offset="0.45" style={{stopColor: "#989898"}} />
		<stop offset="0.62" style={{stopColor: "#858585"}} />
		<stop offset="0.77" style={{stopColor: "#727272"}} />
		<stop offset="1" style={{stopColor: "#1E1E1E"}} />
	</linearGradient>
	<path fill={`url(#${id}_3_)`} d="M29.084,91.082v16.232h5.524V91.082H29.084z" />
	<linearGradient id={`${id}_4_`} gradientUnits="userSpaceOnUse" x1="78.457" y1="99.1982" x2="83.9814" y2="99.1982">
		<stop offset="0" style={{stopColor: "#1E1E1E"}} />
		<stop offset="0.45" style={{stopColor: "#989898"}} />
		<stop offset="0.62" style={{stopColor: "#858585"}} />
		<stop offset="0.77" style={{stopColor: "#727272"}} />
		<stop offset="1" style={{stopColor: "#1E1E1E"}} />
	</linearGradient>
	<path fill={`url(#${id}_4_)`} d="M78.457,91.082v16.232h5.524V91.082H78.457z" />
	<linearGradient id={`${id}_5_`} gradientUnits="userSpaceOnUse" x1="76.541" y1="108.4043" x2="85.8984" y2="108.4043">
		<stop offset="0" style={{stopColor: "#1E1E1E"}} />
		<stop offset="0.45" style={{stopColor: "#989898"}} />
		<stop offset="0.62" style={{stopColor: "#858585"}} />
		<stop offset="0.77" style={{stopColor: "#727272"}} />
		<stop offset="1" style={{stopColor: "#1E1E1E"}} />
	</linearGradient>
	<polygon fill={`url(#${id}_5_)`} points="83.08,107.146 76.541,107.146 76.541,109.661 83.08,109.661 85.898,109.661 85.898,107.146     " />
	<linearGradient id={`${id}_6_`} gradientUnits="userSpaceOnUse" x1="27.168" y1="108.4043" x2="36.5239" y2="108.4043">
		<stop offset="0" style={{stopColor: "#1E1E1E"}} />
		<stop offset="0.45" style={{stopColor: "#989898"}} />
		<stop offset="0.62" style={{stopColor: "#858585"}} />
		<stop offset="0.77" style={{stopColor: "#727272"}} />
		<stop offset="1" style={{stopColor: "#1E1E1E"}} />
	</linearGradient>
	<polygon fill={`url(#${id}_6_)`} points="33.706,107.146 27.168,107.146 27.168,109.661 33.706,109.661 36.524,109.661    36.524,107.146  " />
</g>
<g id="Group_TankBody">
	
		<radialGradient id={`${id}_7_`} cx="46.895" cy="21.7563" r="33.2099" gradientTransform="matrix(1 0 0 1.4941 0 -11.182)" gradientUnits="userSpaceOnUse">
		<stop offset="0" style={{stopColor: "#EBEBEB"}} />
		<stop offset="0.03" style={{stopColor: "#E5E5E5"}} />
		<stop offset="0.7" style={{stopColor: "#777777"}} />
		<stop offset="1" style={{stopColor: "#4C4C4C"}} />
	</radialGradient>
	<path fill={`url(#${id}_7_)`} d="M0.452,28.783h92.886L79.473,13.865H14.43L0.452,28.783" />
	<linearGradient id={`${id}_8_`} gradientUnits="userSpaceOnUse" x1="7.3281" y1="17.501" x2="86.4609" y2="17.501">
		<stop offset="0" style={{stopColor: "#1E1E1E"}} />
		<stop offset="0.48" style={{stopColor: "#868686"}} />
		<stop offset="0.6" style={{stopColor: "#737373"}} />
		<stop offset="0.84" style={{stopColor: "#434343"}} />
		<stop offset="1" style={{stopColor: "#1E1E1E"}} />
	</linearGradient>
	<path fill={`url(#${id}_8_)`} d="M86.461,21.531c-46.99-10.981-79.133,0-79.133,0l7.66-8.035l63.903-0.025L86.461,21.531z" />
	<linearGradient id={`${id}_9_`} gradientUnits="userSpaceOnUse" x1="0.4521" y1="47.0068" x2="93.3379" y2="47.0068">
		<stop offset="0" style={{stopColor: "#373737"}} />
		<stop offset="0.5" style={{stopColor: "#EBEBEB"}} />
		<stop offset="0.57" style={{stopColor: "#D8D8D8"}} />
		<stop offset="0.71" style={{stopColor: "#A7A7A7"}} />
		<stop offset="0.92" style={{stopColor: "#595959"}} />
		<stop offset="1" style={{stopColor: "#373737"}} />
	</linearGradient>
	<path fill={`url(#${id}_9_)`} d="M0.452,28.407v37.2h92.886v-37.2H0.452" />
	
		<radialGradient id={`${id}_10_`} cx="46.895" cy="77.3506" r="33.8509" gradientTransform="matrix(1 0 0 1.9154 0 -71.0336)" gradientUnits="userSpaceOnUse">
		<stop offset="0" style={{stopColor: "#EBEBEB"}} />
		<stop offset="0.14" style={{stopColor: "#DCDCDC"}} />
		<stop offset="0.4" style={{stopColor: "#B7B7B7"}} />
		<stop offset="0.75" style={{stopColor: "#7B7B7B"}} />
		<stop offset="1" style={{stopColor: "#4C4C4C"}} />
	</radialGradient>
	<path fill={`url(#${id}_10_)`} d="M0.452,65.418l23.221,23.41h46.443l23.222-23.41" />
	<linearGradient id={`${id}_11_`} gradientUnits="userSpaceOnUse" x1="23.6733" y1="91.2305" x2="70.1162" y2="91.2305">
		<stop offset="0" style={{stopColor: "#373737"}} />
		<stop offset="0.49" style={{stopColor: "#EBEBEB"}} />
		<stop offset="0.56" style={{stopColor: "#D8D8D8"}} />
		<stop offset="0.71" style={{stopColor: "#A7A7A7"}} />
		<stop offset="0.92" style={{stopColor: "#595959"}} />
		<stop offset="1" style={{stopColor: "#373737"}} />
	</linearGradient>
	<path fill={`url(#${id}_11_)`} d="M23.673,88.731l23.222,4.997l23.221-4.997" />
</g>
<g id="Group_Top">
	<linearGradient id={`${id}_12_`} gradientUnits="userSpaceOnUse" x1="0.4521" y1="4.1895" x2="93.3379" y2="4.1895">
		<stop offset="0" style={{stopColor: "#373737"}} />
		<stop offset="0.45" style={{stopColor: "#EBEBEB"}} />
		<stop offset="0.53" style={{stopColor: "#D8D8D8"}} />
		<stop offset="0.69" style={{stopColor: "#A7A7A7"}} />
		<stop offset="0.91" style={{stopColor: "#595959"}} />
		<stop offset="1" style={{stopColor: "#373737"}} />
	</linearGradient>
	<path fill={`url(#${id}_12_)`} d="M93.338,7.816l-2.255-7.252H2.819L0.452,7.816" />
	<linearGradient id={`${id}_13_`} gradientUnits="userSpaceOnUse" x1="0.4521" y1="10.9346" x2="93.3379" y2="10.9346">
		<stop offset="0" style={{stopColor: "#1E1E1E"}} />
		<stop offset="0.51" style={{stopColor: "#989898"}} />
		<stop offset="0.61" style={{stopColor: "#858585"}} />
		<stop offset="0.8" style={{stopColor: "#545454"}} />
		<stop offset="1" style={{stopColor: "#1E1E1E"}} />
	</linearGradient>
	<path fill={`url(#${id}_13_)`} d="M79.473,14.429h11.61l2.255-6.989H0.452l2.367,6.989h11.61" />
</g>
<g id="Group_FrontLegs">
	<linearGradient id={`${id}_14_`} gradientUnits="userSpaceOnUse" x1="5.1865" y1="110.7715" x2="16.7974" y2="110.7715">
		<stop offset="0" style={{stopColor: "#373737"}} />
		<stop offset="0.45" style={{stopColor: "#EBEBEB"}} />
		<stop offset="0.55" style={{stopColor: "#D8D8D8"}} />
		<stop offset="0.76" style={{stopColor: "#A7A7A7"}} />
		<stop offset="0.77" style={{stopColor: "#A5A5A5"}} />
		<stop offset="1" style={{stopColor: "#373737"}} />
	</linearGradient>
	<polygon fill={`url(#${id}_14_)`} points="13.303,109.514 5.187,109.514 5.187,112.029 13.303,112.029 16.797,112.029    16.797,109.514  " />
	<linearGradient id={`${id}_15_`} gradientUnits="userSpaceOnUse" x1="5.1865" y1="88.7676" x2="16.7974" y2="88.7676">
		<stop offset="0" style={{stopColor: "#373737"}} />
		<stop offset="0.45" style={{stopColor: "#EBEBEB"}} />
		<stop offset="0.55" style={{stopColor: "#D8D8D8"}} />
		<stop offset="0.76" style={{stopColor: "#A7A7A7"}} />
		<stop offset="0.77" style={{stopColor: "#A5A5A5"}} />
		<stop offset="1" style={{stopColor: "#373737"}} />
	</linearGradient>
	<path fill={`url(#${id}_15_)`} d="M16.797,78.908c0,0,0-5.742-3.178-8.242c-3.943-3.102-8.433-2.805-8.433-2.805v23.221h2.254v18.6   h6.989v-18.6h2.368V78.908" />
	<linearGradient id={`${id}_16_`} gradientUnits="userSpaceOnUse" x1="57.9414" y1="88.7891" x2="69.5527" y2="88.7891">
		<stop offset="0" style={{stopColor: "#373737"}} />
		<stop offset="0.45" style={{stopColor: "#EBEBEB"}} />
		<stop offset="0.55" style={{stopColor: "#D8D8D8"}} />
		<stop offset="0.76" style={{stopColor: "#A7A7A7"}} />
		<stop offset="0.77" style={{stopColor: "#A5A5A5"}} />
		<stop offset="1" style={{stopColor: "#373737"}} />
	</linearGradient>
	<path fill={`url(#${id}_16_)`} d="M69.553,75.389c0-10.389-11.611-9.639-11.611,0.188v15.505h2.367v18.6h6.99v-18.6h2.254" />
	<linearGradient id={`${id}_17_`} gradientUnits="userSpaceOnUse" x1="60.2529" y1="100.3818" x2="67.2422" y2="100.3818">
		<stop offset="0" style={{stopColor: "#373737"}} />
		<stop offset="0.45" style={{stopColor: "#EBEBEB"}} />
		<stop offset="0.55" style={{stopColor: "#D8D8D8"}} />
		<stop offset="0.76" style={{stopColor: "#A7A7A7"}} />
		<stop offset="0.77" style={{stopColor: "#A5A5A5"}} />
		<stop offset="1" style={{stopColor: "#373737"}} />
	</linearGradient>
	<path fill={`url(#${id}_17_)`} d="M60.253,91.082v18.6h6.989v-18.6" />
	<linearGradient id={`${id}_18_`} gradientUnits="userSpaceOnUse" x1="7.4971" y1="100.3818" x2="14.4863" y2="100.3818">
		<stop offset="0" style={{stopColor: "#373737"}} />
		<stop offset="0.45" style={{stopColor: "#EBEBEB"}} />
		<stop offset="0.55" style={{stopColor: "#D8D8D8"}} />
		<stop offset="0.76" style={{stopColor: "#A7A7A7"}} />
		<stop offset="0.77" style={{stopColor: "#A5A5A5"}} />
		<stop offset="1" style={{stopColor: "#373737"}} />
	</linearGradient>
	<path fill={`url(#${id}_18_)`} d="M7.497,91.082v18.6h6.989v-18.6" />
	<linearGradient id={`${id}_19_`} gradientUnits="userSpaceOnUse" x1="57.9414" y1="110.7715" x2="69.5527" y2="110.7715">
		<stop offset="0" style={{stopColor: "#373737"}} />
		<stop offset="0.45" style={{stopColor: "#EBEBEB"}} />
		<stop offset="0.55" style={{stopColor: "#D8D8D8"}} />
		<stop offset="0.76" style={{stopColor: "#A7A7A7"}} />
		<stop offset="0.77" style={{stopColor: "#A5A5A5"}} />
		<stop offset="1" style={{stopColor: "#373737"}} />
	</linearGradient>
	<polygon fill={`url(#${id}_19_)`} points="66.059,109.514 57.941,109.514 57.941,112.029 66.059,112.029 69.553,112.029    69.553,109.514  " />
</g>
    
      </g>
      <rect x="0" y="0" width="93.902" height="112.5" fill={`url(#fp-shine-${id})`} style={{pointerEvents:"none"}}/>
    </svg>
  );
}
